export default __webpack_public_path__ + "static/media/countDown_watch.1b6abb04.svg";